module.exports = __webpack_public_path__ + "img/Comic05-2.e51c3d59.png";